module.exports = __webpack_public_path__ + "img/04n.b3b1763c.svg";